const INITIAL_STATE = {
  exercices: [
    "SQUAT",
    "JUMPING-JACK",
    "BURPEES",
    "MOUNTAIN-CLIMBER",
    "POMPE",
    "CRUNCH",
    "DIPS",
    "GAINAGE",
  ],
  preparation: 3,
  currentExercice: 0,
  interval: 8,
  currentInterval: 1,
  active: 20,
  currentActive: 20,
  passive: 10,
  currentPassive: 10,
  pause: 60,
  currentPause: 60,
  lap: 4,
  currentLap: 1,
  preparationActive: true,
  workActive: false,
  restActive: false,
  pauseActive: false,
  end: false,
};

function counterReducer(state = INITIAL_STATE, action) {
  //////////////////////// active timer
  switch (action.type) {
    case "ACTIVE-TIMER":
      ///////////////// update lap

      if (
        state.currentInterval <= state.interval &&
        state.currentLap <= state.lap
      ) {
        ///////////////// update preparation
        if (state.preparationActive === true && state.preparation > 0) {
          return {
            ...state,
            end: false,
            preparation: state.preparation - 1,
          };
        } else if (state.preparationActive === true && state.preparation <= 0) {
          return {
            ...state,
            preparationActive: false,
            workActive: true,
          };
        }
        ///////////////// update interval

        if (state.currentActive > 0 && state.workActive === true) {
          return {
            ...state,
            currentActive: state.currentActive - 1,
          };
        } else if (state.currentActive <= 0 && state.workActive === true) {
          return {
            ...state,
            workActive: false,
            restActive: true,

            currentActive: state.active,
          };
        } else if (state.restActive === true) {
          if (state.currentPassive > 0) {
            return {
              ...state,

              currentPassive: state.currentPassive - 1,
            };
          }

          if (
            state.currentPassive <= 0 &&
            state.currentInterval !== state.interval
          ) {
            return {
              ...state,
              currentInterval: state.currentInterval + 1,

              currentExercice: state.currentExercice + 1,

              workActive: true,
              restActive: false,

              currentPassive: state.passive,
            };
          }
          if (
            state.currentPassive <= 0 &&
            state.currentInterval === state.interval
          ) {
            return {
              ...state,

              workActive: false,
              restActive: false,
              pauseActive: true,

              currentPassive: state.passive,
            };
          }
        }
        if (state.pauseActive === true && state.currentPause > 0) {
          return {
            ...state,
            currentPause: state.currentPause - 1,
          };
        }
        if (
          /// fin du tour
          state.pauseActive === true &&
          state.currentPause <= 0 &&
          state.currentLap < state.lap
        ) {
          return {
            ...state,
            currentExercice: 0,

            currentLap: state.currentLap + 1,
            currentInterval: 1,

            workActive: true,
            pauseActive: false,
          };
        }
        if (
          //// fin du dernier tour
          state.pauseActive === true &&
          state.currentPause <= 0 &&
          state.currentLap === state.lap
        ) {
          return {
            ...state,

            currentExercice: 0,

            workActive: false,
            restActive: false,
            pauseActive: false,
            end: true,
          };
        }
        // if (state.pauseActive === true && state.currentPause <= 0) {
        //   return {
        //     ...state,
        //     // currentLap: state.currentLap + 1,
        //     // currentInterval: 1,
        //     // preparation: 3,

        //     preparationActive: true,
        //     workActive: false,
        //     pauseActive: false,
        //   };
        // }
      } else {
        return {
          ...state,
          currentInterval: 1,
          currentLap: state.currentLap + 1,
        };
      }
    ///////////////////////// reset

    case "RESET":
      return {
        ...state,
        currentActive: state.active,
        currentPassive: state.passive,
        currentPause: state.pause,

        currentInterval: 1,
        currentLap: 1,
        currentExercice: 0,
        preparation: 3,

        preparationActive: true,
        workActive: false,
        restActive: false,
        pauseActive: false,
      };

    //////////////////////   interval
    case "MORE-INT":
      if (state.interval < 15 && state.interval > 1) {
        return {
          ...state,
          interval: state.interval + 1,

          exercices: action.tab,
        };
      } else {
        return {
          ...state,
          interval: state.interval,
        };
      }
    case "LESS-INT":
      if (state.interval > 2) {
        return {
          ...state,
          interval: state.interval - 1,

          exercices: action.tab,
        };
      } else {
        return {
          ...state,
          interval: state.interval,
          exercices: action.tab,
        };
      }

    ///////////////////////   active

    case "MORE-ACT":
      if (state.active < 60) {
        return {
          ...state,
          active: state.active + 5,
          currentActive: state.currentActive + 5,
        };
      } else {
        return {
          ...state,
          active: state.active,
          currentActive: state.currentActive,
        };
      }
    case "LESS-ACT":
      if (state.active > 5) {
        return {
          ...state,
          active: state.active - 5,
          currentActive: state.currentActive - 5,
        };
      } else {
        return {
          ...state,
          active: state.active,
          currentActive: state.currentActive,
        };
      }

    /////////////////////// passive
    case "MORE-PAS":
      if (state.passive < 60) {
        return {
          ...state,
          passive: state.passive + 5,
          currentPassive: state.currentPassive + 5,
        };
      } else {
        return {
          ...state,
          passive: state.passive,
        };
      }
    case "LESS-PAS":
      if (state.passive > 4) {
        return {
          ...state,
          passive: state.passive - 5,
          currentPassive: state.currentPassive - 5,
        };
      } else {
        return {
          ...state,
          passive: state.passive,
        };
      }

    /////////////////////// pause
    case "MORE-PAU":
      if (state.pause < 300) {
        return {
          ...state,
          pause: state.pause + 10,
          currentPause: state.currentPause + 10,
        };
      } else {
        return {
          ...state,
          pause: state.pause,
        };
      }
    case "LESS-PAU":
      if (state.pause > 9) {
        return {
          ...state,
          pause: state.pause - 10,
          currentPause: state.currentPause - 10,
        };
      } else {
        return {
          ...state,
          pause: state.pause,
        };
      }

    /////////////////////// lap
    case "MORE-LAP":
      if (state.lap < 20) {
        return {
          ...state,
          lap: state.lap + 1,
        };
      } else {
        return {
          ...state,
          lap: state.lap,
        };
      }
    case "LESS-LAP":
      if (state.lap > 1) {
        return {
          ...state,
          lap: state.lap - 1,
        };
      } else {
        return {
          ...state,
          lap: state.lap,
        };
      }
    /////////////////// input

    case "ADD-EX":
      return {
        ...state,
        exercices: action.tab,
      };
  }

  return state;
}

export default counterReducer;
